import TealiumUniversalTag from "@nib/tealium-universal-tag";

import { metrics } from "react-metrics";
import trackPage from "@nib/track-page";

const configureUtag = (environmentVariables: any): any => {
  const tealiumTagOptions = {
    account: environmentVariables.REACT_APP_TELIUM_ACCOUNT || "nib",
    environment: environmentVariables.REACT_APP_TELIUM_ENVIRONMENT || "qa",
    profile: environmentVariables.REACT_APP_TELIUM_PROFILE || "main",
  };

  const tealiumUTag = new TealiumUniversalTag({
    ...tealiumTagOptions,
    manualPageView: true,
  });

  return tealiumUTag;
};

export const wrapWithMetrics = (
  page: () => JSX.Element,
  environmentVariables: any,
): (() => JSX.Element) => {
  const track = trackPage({
    channel: "Online",
    site_name: process.env.REACT_APP_AUTH_DOMAIN || "id.guhealth.com.au",
    site_section: "online_services",
    page_name: "auth0-login-pages",
    page_type: "online_services",
  });

  const nibMetricsConfig = {
    vendors: [
      {
        name: "Tealium Universal Tag",
        api: configureUtag(environmentVariables),
      },
    ],
  };
  return metrics(nibMetricsConfig)(track(page));
};
